<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import DashboardBase from '../../../dashboard/components/DashboardBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        filterSideBar: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <DashboardBase />
</template>